import { render, staticRenderFns } from "./PlateFieldForm.vue?vue&type=template&id=3a1c57ae&scoped=true&"
import script from "./PlateFieldForm.vue?vue&type=script&lang=js&"
export * from "./PlateFieldForm.vue?vue&type=script&lang=js&"
import style0 from "./PlateFieldForm.vue?vue&type=style&index=0&id=3a1c57ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c57ae",
  null
  
)

export default component.exports